import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import RunDynamicExtract from './RunDynamicExtract';
import RunDynamicExtractProvider from './RunDynamicExtract.context';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import { IExtractMaintenanceProps } from './RunDynamicExtract.properties';
import { selectors as extractMaintenanceSelectors } from 'ducks/extractMaintenance/extractMaintenanceTemplates';

const mapStateToProps = (state) => {
    const params = new URLSearchParams(location.search);

    return ({
        selectedTemplateId: extractMaintenanceSelectors.selected(state)?.TemplateId ?? params.get('TemplateId'),
        isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
        isExtractMaintenanceLookUpOpen: uiSelectors.isExtractMaintenanceLookUpOpen(state),
    });
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        toggleMenuOption: uiActions.toggleMenuOption,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<
    IExtractMaintenanceProps>) => {
    return (
        <RunDynamicExtractProvider>
            <RunDynamicExtract {...props} />
        </RunDynamicExtractProvider>
    );
});
